export default function ingredientValidator(data) {
  let errors = {}
  const noEmpty = ["name", "note"]

  noEmpty.forEach(field => {
    if (!data[field]) {
      errors[field] = "can't be blank"
    }
  })

  if (!data.example && data.value_type.indexOf("date") === -1) {
    errors.example = "can't be blank"
  }

  if (!data.slug) {
    errors.slug = "can't be blank"
  } else if (!data.slug.match(/[A-Za-z0-9_-]/)) {
    errors.slug =
      "can only contain letters, numbers, underscores and dashes, and must begin with a letter"
  }

  return errors
}
